import { ThemeUICSSObject } from '@apia/theme';
import list from './list';
/* IMPORT HERE */

const documents: ThemeUICSSObject = {
  list,
  /* PREPEND HERE */
};

export default documents;
